import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import StaffLayout from "@/components/StaffLayout";
import PortalLayout from "@/components/PortalLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/staff/Dashboard";
import Clients from "@/pages/staff/Clients";
import ClientDetail from "@/pages/staff/ClientDetail";
import Disputes from "@/pages/staff/Disputes";
import DisputeDetail from "@/pages/staff/DisputeDetail";
import Billing from "@/pages/staff/Billing";
import AuditLog from "@/pages/staff/AuditLog";
import Team from "@/pages/staff/Team";
import Settings from "@/pages/staff/Settings";
import HelpCenter from "@/pages/staff/HelpCenter";
import TrainingCenter from "@/pages/staff/TrainingCenter";
import Organizations from "@/pages/staff/Organizations";
import AgencySignup from "@/pages/AgencySignup";
import Landing from "@/pages/Landing";
import DiyLayout from "@/components/DiyLayout";
import DiyHome from "@/pages/diy/DiyHome";
import DiyItems from "@/pages/diy/DiyItems";
import DiyInfo from "@/pages/diy/DiyInfo";
import PortalHome from "@/pages/portal/PortalHome";
import Onboarding from "@/pages/portal/Onboarding";
import Documents from "@/pages/portal/Documents";
import SignAgreement from "@/pages/portal/SignAgreement";
import PortalBilling from "@/pages/portal/PortalBilling";
import Guides from "@/pages/portal/Guides";

function Loading() {
  return <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">Loading…</div>;
}

function StaffRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "client") return <Navigate to="/portal" replace />;
  if (user.role === "diy") return <Navigate to="/diy" replace />;
  return children;
}

function ClientRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "diy") return <Navigate to="/diy" replace />;
  if (user.role !== "client") return <Navigate to="/admin" replace />;
  return children;
}

function DiyRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "client") return <Navigate to="/portal" replace />;
  if (user.role !== "diy") return <Navigate to="/admin" replace />;
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "client" ? "/portal" : user.role === "diy" ? "/diy" : "/admin"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/home" element={<HomeRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/agency-signup" element={<AgencySignup />} />
            <Route path="/admin" element={<StaffRoute><StaffLayout /></StaffRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:cid" element={<ClientDetail />} />
              <Route path="disputes" element={<Disputes />} />
              <Route path="disputes/:did" element={<DisputeDetail />} />
              <Route path="billing" element={<Billing />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="team" element={<Team />} />
              <Route path="settings" element={<Settings />} />
              <Route path="organizations" element={<Organizations />} />
              <Route path="training" element={<TrainingCenter />} />
              <Route path="help" element={<HelpCenter />} />
            </Route>
            <Route path="/portal" element={<ClientRoute><PortalLayout /></ClientRoute>}>
              <Route index element={<PortalHome />} />
              <Route path="onboarding" element={<Onboarding />} />
              <Route path="documents" element={<Documents />} />
              <Route path="sign" element={<SignAgreement />} />
              <Route path="billing" element={<PortalBilling />} />
              <Route path="guides" element={<Guides />} />
            </Route>
            <Route path="/diy" element={<DiyRoute><DiyLayout /></DiyRoute>}>
              <Route index element={<DiyHome />} />
              <Route path="items" element={<DiyItems />} />
              <Route path="info" element={<DiyInfo />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
